// extracted by mini-css-extract-plugin
export default {"container":"lj-z","links":"mj-z"};